var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrioCirculoFundopreto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 251,
    viewBox: "0 0 24 251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trio-circulo-fundopreto",
    transform: "translate(-160 -429.4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_1",
    "data-name": "Elipse 1",
    cx: 12,
    cy: 11.5,
    rx: 12,
    ry: 11.5,
    transform: "translate(160 429.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2",
    "data-name": "Elipse 2",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(160 542.4)",
    fill: "#d51b17"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(160 656.4)",
    fill: "#d7b13b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrioCirculoFundopreto);
export default __webpack_public_path__ + "static/media/trio-circulo-fundopreto.cf114fd765e3a2aace049c6b1aa754e1.svg";
export { ForwardRef as ReactComponent };